import { useRef, useState } from 'react';

/** Reusable drag-and-drop (or click-to-browse) file picker used across all uploads. */
export function FileDropZone({
  accept,
  onFiles,
  hint,
  busy,
  disabled,
  multiple,
}: {
  accept?: string;
  onFiles: (files: File[]) => void;
  hint?: string;
  busy?: boolean;
  disabled?: boolean;
  multiple?: boolean;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);

  const pick = (files: FileList | null) => {
    const arr = Array.from(files ?? []);
    if (arr.length) onFiles(arr);
  };

  return (
    <div
      className="dropzone"
      data-dragging={dragging ? 'true' : undefined}
      data-disabled={disabled ? 'true' : undefined}
      role="button"
      tabIndex={0}
      onClick={() => !disabled && inputRef.current?.click()}
      onKeyDown={(e) => {
        if (!disabled && (e.key === 'Enter' || e.key === ' ')) inputRef.current?.click();
      }}
      onDragOver={(e) => { e.preventDefault(); if (!disabled) setDragging(true); }}
      onDragLeave={(e) => { e.preventDefault(); setDragging(false); }}
      onDrop={(e) => { e.preventDefault(); setDragging(false); if (!disabled) pick(e.dataTransfer.files); }}
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        style={{ display: 'none' }}
        onChange={(e) => { pick(e.target.files); e.target.value = ''; }}
      />
      <div style={{ fontSize: 22, lineHeight: 1 }}>⤓</div>
      <div style={{ fontSize: 14, fontWeight: 600 }}>
        {busy ? 'Working…' : dragging ? 'Drop the file here' : 'Drag & drop a file, or click to browse'}
      </div>
      {hint && <div className="muted" style={{ fontSize: 12 }}>{hint}</div>}
    </div>
  );
}
